"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledGaugeBarIndicator = exports.StyledGaugeBar = exports.StyledHeadingText = exports.StyledLabelsContainer = exports.StyledGaugeLabel = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Text = require("../Text");

var _Heading = require("../Heading");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: calc(", " - 6px);\n  height: calc(", " - 6px);\n  border-radius: 50%;\n  border: 2px solid ", ";\n  background-color: ", ";\n  box-shadow: 0 0 4px 0 rgba(12, 30, 44, 0.4);\n  left: ", "%;\n  animation: ", " 1s ease-in-out forwards;\n  @media screen and (min-width: ", ") {\n    border-width: 3px;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  height: ", ";\n  border-left: 2px solid ", ";\n  border-right: 2px solid ", ";\n  position: relative;\n  &:before {\n    position: absolute;\n    top: calc(50% - 1px);\n    left: 0;\n    right: 0;\n    content: '';\n    display: block;\n    height: 2px;\n    background-color: ", ";\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin-right: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  align-items: baseline;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  float: ", ";\n  margin-top: calc(\n    ", " -\n      ", "\n  );\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        from {\n            left: 0;\n        }\n        to {\n            left: ", "%;\n        }\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var ProgressAnimation = function ProgressAnimation(props) {
  return (0, _styledComponents.keyframes)(_templateObject(), props.value);
};

var StyledGaugeLabel = (0, _styledComponents.default)(_Text.Text)(_templateObject2(), function (props) {
  return props.theme.colors.primaryFont;
}, function (props) {
  return props.position || 'left';
}, function (props) {
  return props.indicatorSize || props.theme.graphs.barGauge.indicatorSize;
}, function (props) {
  return props.height || props.theme.graphs.barGauge.height;
});
exports.StyledGaugeLabel = StyledGaugeLabel;

var StyledLabelsContainer = _styledComponents.default.div(_templateObject3());

exports.StyledLabelsContainer = StyledLabelsContainer;
var StyledHeadingText = (0, _styledComponents.default)(_Heading.Heading)(_templateObject4(), function (props) {
  return props.marginRight;
});
exports.StyledHeadingText = StyledHeadingText;

var StyledGaugeBar = _styledComponents.default.div(_templateObject5(), function (props) {
  return props.height || props.theme.graphs.barGauge.height;
}, function (props) {
  return props.theme.colors.brandThemeDark500;
}, function (props) {
  return props.theme.colors.brandThemeDark500;
}, function (props) {
  return props.theme.colors.brandThemeDark500;
});

exports.StyledGaugeBar = StyledGaugeBar;

var StyledGaugeBarIndicator = _styledComponents.default.div(_templateObject6(), function (props) {
  return props.indicatorSize || props.theme.graphs.barGauge.indicatorSize;
}, function (props) {
  return props.indicatorSize || props.theme.graphs.barGauge.indicatorSize;
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.colors.actionPrimary300;
}, function (props) {
  return props.value;
}, function (props) {
  return ProgressAnimation(props);
}, function (props) {
  return props.theme.breakpoints && props.theme.breakpoints.sm;
});

exports.StyledGaugeBarIndicator = StyledGaugeBarIndicator;